import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GceAmountReducer } from '../reducers';

const selectGceAmountFeature = createFeatureSelector<GceAmountReducer.GceAmountState>(GceAmountReducer.featureName);

export const selectGceAmount = createSelector(selectGceAmountFeature, ({ item }) => item);
